import {put,takeLatest} from 'redux-saga/effects';
import {
    REMOVE_FROM_CART,
    REMOVE_FROM_CART_SUCCESS,
    REMOVE_FROM_CART_ERROR
}
    from "../../actions/cart";

function* removeFromCartaga(action) {
    try {
        yield put({
            type: REMOVE_FROM_CART_SUCCESS,
            payload: action.payload
        });

    } catch(error) {
        yield put({
            type: REMOVE_FROM_CART_ERROR,error: error.data
        });
    }
}


export function* removeFromCartSagaWatcher() {
    yield takeLatest(REMOVE_FROM_CART,removeFromCartaga);
}